var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    className: "icon",
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1152 4.9996H2.88477C2.11981 5.00003 1.38628 5.32943 0.84537 5.91541C0.304456 6.5014 0.000397283 7.29604 0 8.12475V16.8749C0.000397283 17.7036 0.304456 18.4982 0.84537 19.0842C1.38628 19.6702 2.11981 19.9996 2.88477 20H17.1152C17.8802 19.9996 18.6137 19.6702 19.1546 19.0842C19.6955 18.4982 19.9996 17.7036 20 16.8749V8.12475C19.9996 7.29604 19.6955 6.5014 19.1546 5.91541C18.6137 5.32943 17.8802 5.00003 17.1152 4.9996V4.9996Z",
    fill: "#97A7B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1783 0.0520016L2.88507 2.43647C2.01994 2.65088 0.76947 3.59298 0.76947 4.73973C1.07323 4.40089 1.44094 4.13709 1.84747 3.96637C2.254 3.79565 2.68976 3.72203 3.12497 3.75053H16.9191V2.68174C16.9208 1.96293 16.6834 1.26751 16.2504 0.722838C15.9836 0.433374 15.6545 0.220466 15.2927 0.103344C14.9309 -0.0137776 14.5479 -0.031423 14.1783 0.0520016V0.0520016Z",
    fill: "#707070"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestIcon);
export default __webpack_public_path__ + "static/media/request_icon.7ec0a785.svg";
export { ForwardRef as ReactComponent };